import { jsx as _jsx } from "react/jsx-runtime";
import { useAuth } from '#contexts/AuthContext';
import { ThemeProvider } from '@material-ui/core';
import { BaseMuiTheme, Loader } from '@swyft/core';
import { useEffect } from 'react';
export const SignedOutPage = ({ name, redirectPath }) => {
    const { signInRedirect } = useAuth();
    useEffect(() => {
        signInRedirect(redirectPath);
    }, []);
    return (_jsx(ThemeProvider, { theme: BaseMuiTheme, children: _jsx(Loader, {}) }));
};
